module.exports = __webpack_public_path__ + "img/bookmark-active-ic.824ce597.svg";